"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.QualityRatingsTemplate = exports.ReviewAxes = void 0;

var _immutable = require("immutable");

var ReviewAxes = {
  OVERALL: 'OVERALL',
  USABILITY: 'USABILITY',
  FUNCTIONALITY: 'FUNCTIONALITY',
  VALUE: 'VALUE',
  SUPPORT_DOCS: 'SUPPORT_DOCS'
};
exports.ReviewAxes = ReviewAxes;
var QualityRatingsTemplate = (0, _immutable.OrderedMap)({
  USABILITY: null,
  FUNCTIONALITY: null,
  VALUE: null,
  SUPPORT_DOCS: null
});
exports.QualityRatingsTemplate = QualityRatingsTemplate;


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/ecosystem-marketplace-core/static-1.1225/js/constants/reviews/ReviewAxes.js
// module id = 102
// module chunks = 209 210 211 212